<ng-container>
  <div class="cart_item">
    @switch (basketItem.service.type) {
      @case (serviceType.Flight) {
        <app-basket-flight
          [flight]="basketItem"
          [duplicateBooking]="isDuplicate"
        ></app-basket-flight>
      }
      @case (serviceType.Hotel) {
        <app-basket-hotel [hotel]="basketItem" [duplicateBooking]="isDuplicate"></app-basket-hotel>
      }
      @case (serviceType.Rail) {
        <app-basket-rail [rail]="basketItem" [duplicateBooking]="isDuplicate"></app-basket-rail>
      }
      @case (serviceType.Parking) {
        <app-basket-parking
          [parking]="basketItem"
          [duplicateBooking]="isDuplicate"
        ></app-basket-parking>
      }
      @case (serviceType.Lounge) {
        <app-basket-lounge
          [lounge]="basketItem"
          [duplicateBooking]="isDuplicate"
        ></app-basket-lounge>
      }
      @case (serviceType.Cab) {
        <app-basket-taxi [taxi]="basketItem" [duplicateBooking]="isDuplicate"></app-basket-taxi>
      }
      @case (serviceType.Car) {
        <app-basket-car-hire
          [car]="basketItem"
          [hideIcon]="true"
          [duplicateBooking]="isDuplicate"
        ></app-basket-car-hire>
      }
      @case (serviceType.Eurostar) {
        <app-basket-eurostar
          [eurostar]="basketItem"
          [duplicateBooking]="isDuplicate"
        ></app-basket-eurostar>
      }
      @case (serviceType.FastTrack) {
        <app-basket-fast-track
          [fastTrack]="basketItem"
          [duplicateBooking]="isDuplicate"
        ></app-basket-fast-track>
      }
      @case (serviceType.InternationalRail) {
        <app-basket-irl [rail]="basketItem" [duplicateBooking]="isDuplicate"></app-basket-irl>
      }
    }
  </div>
</ng-container>
